<template>
  <v-container fluid class="d-flex flex-wrap justify-space-between">
    <v-card class="mr-3">
      <v-card-title>
        Medlemmer: {{statData.aktivCount}}
      </v-card-title>
    </v-card>
    <v-card class="mr-3">
      <v-card-title>
        Nye denne uge: {{statData.newWeek}}
      </v-card-title>
    </v-card>
    <v-card class="mr-3">
      <v-card-title>
        Nye denne måned: {{statData.newMonth}}
      </v-card-title>
    </v-card>
    <v-card>
      <v-card-title>
        Kontingent i år: {{statData.paymentsYTD}} kr
      </v-card-title>
    </v-card>
  </v-container>
</template>

<script>

import MedlemsService from '@/services/MedlemsService'

export default {
  name: 'Statbar',

  data: () => ({
    statData: {}
  }),
  methods: {
  },
  async mounted () {
    const newStatData = await MedlemsService.getStats()
    this.statData = newStatData.data
  }
}
</script>
